module.exports = __webpack_public_path__ + "img/Selo-Melhor-Provedor.219a75aa.svg";